export default __webpack_public_path__ + "static/media/penguin2.57ecb937.png";